import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Button from '../components/ui/Button';

/**
 * Landing page with language selection
 */
const HomePage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [classType, setClassType] = useState('mandarin');
  
  // If user is already authenticated, redirect to classes page
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/classes');
    }
  }, [isAuthenticated, navigate]);
  
  // Handle language selection
  const handleClassTypeChange = (type) => {
    setClassType(type);
  };
  
  // Find classes button click
  const handleFindClasses = () => {
    if (isAuthenticated) {
      navigate('/classes', { state: { classType } });
    } else {
      navigate('/login');
    }
  };
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center">
      <div 
        className="max-w-lg w-full p-8 rounded-xl shadow-2xl"
        style={{ backgroundColor: 'rgba(20, 20, 20, 0.8)' }}
      >
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 bg-gradient-to-r from-white to-purple-400 text-transparent bg-clip-text">
          Join a Group Class
        </h1>
        
        <p className="text-gray-300 mb-8">
          Tell us which type of class you're interested in:
        </p>
        
        <div className="mb-8 flex flex-col items-center">
          <div className="flex space-x-6">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="classType"
                checked={classType === 'mandarin'}
                onChange={() => handleClassTypeChange('mandarin')}
                className="sr-only"
              />
              <div className="w-5 h-5 mr-3 rounded-full flex items-center justify-center border-2"
                style={{ 
                  borderColor: classType === 'mandarin' ? '#7e55f6' : 'rgba(255,255,255,0.3)',
                }}
              >
                {classType === 'mandarin' && (
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#7e55f6' }}></div>
                )}
              </div>
              <span>Mandarin</span>
            </label>
            
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="classType"
                checked={classType === 'cantonese'}
                onChange={() => handleClassTypeChange('cantonese')}
                className="sr-only"
              />
              <div className="w-5 h-5 mr-3 rounded-full flex items-center justify-center border-2"
                style={{ 
                  borderColor: classType === 'cantonese' ? '#7e55f6' : 'rgba(255,255,255,0.3)',
                }}
              >
                {classType === 'cantonese' && (
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#7e55f6' }}></div>
                )}
              </div>
              <span>Cantonese</span>
            </label>
          </div>
        </div>
        
        <Button
          onClick={handleFindClasses}
          variant="primary"
          size="large"
          fullWidth
        >
          Find Available Classes
        </Button>
        
        {!isAuthenticated && (
          <div className="mt-6 text-sm text-gray-400">
            You'll need to log in or create an account to join a class.
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;